import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { ModalService } from 'src/app/services/modal.service';
import { Department } from '../../menu/menu.model';
import { MainStore } from 'src/app/common/main.store';
import { CurrentUser } from 'src/app/common/currentuser.model';
import { SynchronizationService } from '../../features/synchronization/synchronization.service';
import { CommonService } from 'src/app/services/common.service';
import { environment } from 'src/environments/environment';
import { TranslationsService } from '../../features/admin/translations/translations.service';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-top-sub-menu',
    templateUrl: './top-sub-menu.component.html',
    styleUrl: './top-sub-menu.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DatePipe, RouterLink, RouterLinkActive]
})
export class TopSubMenuComponent implements OnInit {

  // Dropdowns
  selectedDepartment: Department = {} as Department;
  currentUser: CurrentUser = {} as CurrentUser;
  isAdminUser: boolean = false;

  // Sproglag
  latestImportDate: Date | null = null;
  environment: string = environment.environment;

  constructor(
    public router: Router,
    public modalService: ModalService,
    private store: MainStore,
    private commonService: CommonService,
    private syncService: SynchronizationService,
    private translation: TranslationsService
  ) {
    this.currentUser = this.store.currentUser.get();
    this.isAdminUser = this.currentUser.isAdmin && this.currentUser.departmentCode == '200'
    this.selectedDepartment = this.store.selectedDepartment.get() ?? {} as Department;
  }

  ngOnInit(): void {
    this.translation.getLatestImportDate().then((date) => {
      this.latestImportDate = date;
    }).catch((error) => {
    });
  }

  /** router.url uden query-string og fragment. */
  private currentPath(): string {
    return this.router.url.split(/[?#]/)[0];
  }

  /**
   * Synkroniserings-sektionen har nu faner (/synchronizations + child routes), så den
   * gamle eksakte URL-sammenligning ville skjule hele sub-baren på fanerne.
   */
  isSynchronizationSection(): boolean {
    const path = this.currentPath();
    return path === '/synchronizations' || path.startsWith('/synchronizations/');
  }

  /** "Opret Synkronisering" hører kun til oversigtsfanen. */
  isSynchronizationListTab(): boolean {
    return this.currentPath() === '/synchronizations';
  }

  /** Fanerne ligger i ?tab=, så stien alene afgør det. */
  isAdminDashboard(): boolean {
    return this.currentPath() === '/admin-dashboard';
  }

  createSync(event: any): void {
    event.preventDefault();
    this.modalService.showCreateSyncronizationContract();
  }

  createCompany(event: any): void {
    event.preventDefault();
    this.commonService.CreateCompany.emit();
  }

  downloadConsoleApp(event: any): void {
    event.preventDefault();
    this.syncService.downloadConsoleApp().subscribe({
      next: (blob) => {

        // Create a URL for the blob and trigger the download
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = '365tid.Sync.Console.zip';
        a.click();
        window.URL.revokeObjectURL(url);
      },
      error: (error) => {
        console.error('Error downloading file', error);
      }
    });
  }

  openTranslationsImportModal(event: any): void {
    event.preventDefault();
    const latestImportDate = this.latestImportDate;
    const formattedDate = latestImportDate
      ? `${latestImportDate.getFullYear()}-${String(latestImportDate.getMonth() + 1).padStart(2, '0')}-${String(latestImportDate.getDate()).padStart(2, '0')}`
      : '';

    this.commonService.ImportTranslations.emit(formattedDate);
  }

  /** Faste data (Permission/Reporting*) fra det forrige miljø — knap på /customer-administration. */
  openSharedDataImportModal(event: Event): void {
    event.preventDefault();
    this.modalService.showSharedDataImportModal();
  }

}
